import {
 createContext,
 useContext,
 useEffect,
 useState,
 ReactNode
} from 'react'

type Theme = 'light' | 'dark'

interface ThemeContextProps {
 theme: Theme
 toggleTheme: () => void
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined)

export function ThemeProvider({ children }: { children: ReactNode }) {
 // Detectar tema do sistema ou localStorage

 function getInitialTheme(): Theme {
  if (typeof window !== 'undefined') {
   const storedTheme = localStorage.getItem('theme') as Theme | null
   const systemPrefersDark = window.matchMedia(
    '(prefers-color-scheme: dark)'
   ).matches
   return storedTheme ?? (systemPrefersDark ? 'dark' : 'light')
  }
  return 'light'
 }

 const [theme, setTheme] = useState<Theme>(getInitialTheme)

 // Atualizar localStorage e html quando mudar o tema
 useEffect(() => {
  localStorage.setItem('theme', theme)
  applyTheme(theme)
 }, [theme])

 function toggleTheme() {
  setTheme(prev => (prev === 'light' ? 'dark' : 'light'))
 }

 function applyTheme(current: Theme) {
  document.documentElement.setAttribute('data-theme', current)
 }

 return (
  <ThemeContext.Provider value={{ theme, toggleTheme }}>
   {children}
  </ThemeContext.Provider>
 )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTheme() {
 const context = useContext(ThemeContext)
 if (!context) {
  throw new Error('useTheme deve estar dentro de ThemeProvider')
 }
 return context
}
